<template>
   
    <div ref="modelContainer" class="model-container">
      <div v-for="(annotation, index) in annotations" :key="index" class="annotation"
        :style="{ left: annotation.position.x + 'px', top: annotation.position.y + 'px', display: annotation.visible ? 'block' : 'none' }"
        @mouseenter="showAnnotation(annotation)" @mouseleave="hideAnnotation(annotation)">
        {{ annotation.name }}
      </div>
      <div v-for="(dot, index) in dots" :key="'dot-' + index" class="dot"
        :style="{ left: dot.position.x + 'px', top: dot.position.y + 'px' }"
        @mouseenter="showAnnotation(dot.annotation)" @mouseleave="hideAnnotation(dot.annotation)"></div>
    </div>
</template>

<script setup name="model3d">
import { onMounted, ref } from 'vue';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import mitter from '@/utils/mitt';

const modelContainer = ref(null);
const annotations = ref([]);
const dots = ref([]);
const outerVisible = ref(false)
const size = ref({
    width:500,
    height:430
})
mitter.on("showflag3d",(val)=>{
     
    console.log(val);
    outerVisible.value = val
   
  })
// 定义需要显示绿点的部件名字列表
const visibleDotsList = ['Tube002', 'NGon615', 'Cylinder537']; // 替换为你的部件名字

// 定义 showAnnotation 和 hideAnnotation 函数
function showAnnotation(annotation) {
  annotation.visible = true;
  console.log('鼠标悬停在部件上，注释名字:', annotation.name); // 在控制台打印注释的名字
}

function hideAnnotation(annotation) {
  annotation.visible = false;
}

onMounted(() => {
  // const scene = new THREE.Scene();
  // const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 10000);
  // const renderer = new THREE.WebGLRenderer();
  // renderer.setSize(window.innerWidth, window.innerHeight);
  // modelContainer.value.appendChild(renderer.domElement);
  // renderer.setClearColor(0xd3d3d3, 1); // 设置背景色为黑色

 
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 10000);
  const renderer = new THREE.WebGLRenderer();
  // console.log(size.width.value,size.height.value);

  // renderer.setSize(size.width.value,size.height.value);
  renderer.setSize(500,430);

  modelContainer.value.appendChild(renderer.domElement);

  renderer.setClearColor(0x042A49, 1); 

  // 添加灯光
  const ambientLight = new THREE.AmbientLight(0xffffff, 2); // 环境光，增加强度
  scene.add(ambientLight);

  const directionalLight = new THREE.DirectionalLight(0xffffff, 2); // 方向光，增加强度
  directionalLight.position.set(0, 1, 0);
  scene.add(directionalLight);

  // 创建OrbitControls
  const controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true; // 启用阻尼效果
  controls.dampingFactor = 0.1; // 阻尼系数

  const loader = new GLTFLoader();
  loader.load(
    'static/dev2.glb',  // 模型文件路径
    (gltf) => {
      const model = gltf.scene;
      scene.add(model);

      // 应用初始旋转（水平旋转90度）
      model.rotation.y = THREE.MathUtils.degToRad(90);

      // 计算模型的边界框，以便知道模型的尺寸和位置
      const box = new THREE.Box3().setFromObject(model);
      const size = box.getSize(new THREE.Vector3());
      const center = box.getCenter(new THREE.Vector3());

      // 将模型移动到原点
      model.position.copy(center.negate());

      // 根据模型的尺寸调整相机位置
      const maxSize = Math.max(size.x, size.y, size.z);
      camera.position.set(0, 0, maxSize * 1.5);
      camera.lookAt(0, 0, 0); // 相机朝向原点

      // 更新控制器的目标点
      controls.target.set(0, 0, 0);

      // 调整模型材质
      model.traverse((child) => {
        if (child.isMesh) {
          child.name = child.name || 'Unnamed_Mesh'; // 确保名称存在

          // 检查部件名字是否在 visibleDotsList 中
          if (visibleDotsList.includes(child.name)) {
            // 创建注释
            const annotation = {
              name: child.name,
              position: new THREE.Vector2(0, 0), // 初始位置
              visible: false, //是否启用注释
              mesh: child // 存储对网格的引用
            };
            annotations.value.push(annotation);

            // 创建绿色点
            const dot = {
              position: new THREE.Vector2(0, 0), // 初始位置
              annotation: annotation // 关联的注释
            };
            dots.value.push(dot);
          }
        }
      });

      // 动画循环
      const animate = () => {
        requestAnimationFrame(animate);
        controls.update(); // 更新控制器
        renderer.render(scene, camera);
        updateAnnotations(); // 更新注释位置
      };

      animate();
    },
    (undefined) => {
      // 进度事件，可以用于加载进度条等
    },
    (error) => {
      console.error('An error happened', error);
    }
  );

  // 监听窗口大小变化
  window.addEventListener('resize', onWindowResize, false);

  function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth*0.26, window.innerHeight*0.48);
    controls.update(); // 更新控制器
  }

  // 更新注释位置
  function updateAnnotations() {
    const vector = new THREE.Vector3();
    const canvas = renderer.domElement;

    annotations.value.forEach(annotation => {
      // 获取网格的世界位置
      vector.setFromMatrixPosition(annotation.mesh.matrixWorld);
      // 将世界坐标转换为屏幕坐标
      vector.project(camera);

      // 计算屏幕坐标
      const x = (vector.x * 0.5 + 0.5) * canvas.width;
      const y = -(vector.y * 0.5 - 0.5) * canvas.height;

      // 更新注释的位置
      annotation.position.set(x, y);
    });

    dots.value.forEach(dot => {
      // 获取网格的世界位置
      vector.setFromMatrixPosition(dot.annotation.mesh.matrixWorld);
      // 将世界坐标转换为屏幕坐标
      vector.project(camera);

      // 计算屏幕坐标
      const x = (vector.x * 0.5 + 0.5) * canvas.width;
      const y = -(vector.y * 0.5 - 0.5) * canvas.height;

      // 更新点的位置
      dot.position.set(x, y);
    });
  }
});
</script>

<style>
.modelwrapper{
  width: 80%;
  height: calc(100vh*0.85);
}
.model-container {
  /* width: 100%;

  height: calc(100vh); */
  position: relative;
  color: #171d47;
  
}
.annotation {
 
  position: absolute;
  background-color: rgba(255, 255, 255, 0.7);
  border: 1px solid #000;
  border-radius: 4px;
  padding: 4px 8px;
  pointer-events: none;
  transform: translate(-50%, -100%);
}
.dot {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: green;
  border-radius: 50%;
  cursor: pointer;
  transform: translate(-50%, -50%);
}
</style>